import Carousel from './Carousel'
import { CarouselProvider, useCarousel } from './context'

export { CarouselProvider, useCarousel }
export default Carousel
